<template>
    <a-modal v-model="visible" title="项目主要完成人情况明细" width="67%" centered :maskClosable="false" :keyboard="false" class="diyModelCls">
        <a-spin :spinning="loading">
            <vxe-toolbar size="mini">
                <template v-slot:tools>
                    <a-button type="primary" :loading="saving || loading" @click="insertItem" style="margin-right:10px">新增</a-button>
                </template>
            </vxe-toolbar>
            <vxe-table
                ref="itemTable"
                size="mini"
                resizable
                keep-source
                auto-resize
                row-id="id"
                align="left"
                header-align="center"
                highlight-hover-row
                show-overflow="tooltip"
                :data="editItemData"
                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
            >
                <vxe-table-column
                    type="seq"
                    title="序号"
                    width="70"
                    align="center"
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.xh" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="xm"
                    title="姓名"
                    width="120"
                    header-class-name="required"
                    align="center"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.xm" :maxLength="20" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="xb"
                    title="性别"
                    width="100"
                    align="center"
                    ><template v-slot:edit="scope"> <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="scope.row.xb" /> </template
                ></vxe-table-column>
                <vxe-table-column field="nl" title="年龄" width="100" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                    <template v-slot:edit="scope">
                        <a-input-number size="small" v-model="scope.row.nl" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="zc"
                    title="职称"
                    width="200"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.zc" :maxLength="20" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="gzdw"
                    title="工作单位"
                    min-width="100"
                    header-class-name="required"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.gzdw" :maxLength="100" />
                    </template>
                </vxe-table-column>
                <vxe-table-column title="操作" width="70" align="center">
                    <template v-slot="scope">
                        <span class="btn_edit" @click="removeItem(scope.row)">删除</span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "WcrqkmxEdit",
    props: ["showWcrqkmxEdit", "dataId", "cgsbbmxid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editItemData: [],
            editDataLoading: false,
            editProps: {
                showWcrqkmxEdit: false,
                cgsbbmxid: null
            }
        };
    },
    computed: {
        visible: {
            get() {
                return this.showWcrqkmxEdit;
            },
            set(newVal) {
                this.$emit("update:showWcrqkmxEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    this.loadItemData();
                }
            },
            immediate: true
        }
    },
    methods: {
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemWcrqkmx",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "XH",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        // 新增
        insertItem() {
            // 设置编辑记录
            let xh = this.$refs.itemTable.getTableData().tableData.length + 1;
            this.$refs.itemTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        cgsbbid: this.dataId,
                        cgsbbmxid: this.cgsbbmxid,
                        xh: xh
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemTable.setActiveRow(row);
                });
        },
        // 删除
        removeItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemTable.remove(row);
                    } else {
                        this.editDataLoading = true;
                        this.$FG_http
                            .post("./api/main/zxcggl/cgsbgl/deleteWcrqkmx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editDataLoading = false;
                                if (success) {
                                    this.loadItemData();
                                }
                            });
                    }
                }
            });
        },
        //保存
        onSave() {
            let itemData = this.$refs.itemTable.getInsertRecords().concat(this.$refs.itemTable.getUpdateRecords());
            for (let i = 0; i < itemData.length; i++) {
                if (!itemData[i].xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => {
                        this.$refs.itemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
                if (!itemData[i].gzdw) {
                    this.$FG_message.error("P0001", "工作单位").then(() => {
                        this.$refs.itemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
            }
            // 保存操作
            this.saving = true;
            this.$FG_http
                .post("./api/main/zxcggl/cgsbgl/saveWCRQKMX", {
                    itemData
                })
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 返回列表
                        this.visible = false;
                        // 通知父组件数据已更新
                        this.$emit("dataUpdated", this.dataId);
                    } else {
                        this.$refs.xm.focus();
                    }
                });
        }
    }
};
</script>
